const baseCanonicalUrl = 'https://www.owndays.com/sg/en/contacts';

export const CONTACTS = [
  {
    metaTitle: 'OWNDAYS Contact Lens | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/contacts',
    keywords: 'OWNDAYS Contact Lens, contact lens, Singapore, OWNDAYS',
    ogImage: null,
    description: `OWNDAYS Contact Lens is the in-house contact lens line from OWNDAYS.`,
    canonicalUrl: `${baseCanonicalUrl}`,
  },
  {
    metaTitle: 'Ortho-K Lens | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/contacts/orthok-contactlens',
    keywords:
      'Ortho-K Lens,contact lens,Daily,Weekly,MBS Premium Concept Store,Takashimaya S.C. Premium Concept Store,Singapore,OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/img/ortho-k-lens/ogp_1200x630.jpg',
    description: `Ortho-K, also known as orthokeratology, is the use of customised contact lenses that temporarily reshape the cornea to improve vision during treatment.`,
    canonicalUrl: `${baseCanonicalUrl}/orthok-contactlens`,
  },
  {
    metaTitle: 'OWNDAYS Clear Vision Blue Daily Lens | OWNDAYS Singapore',
    targetPath: '/contacts/clear-contactlens/daily-blue',
    keywords:
      'OWNDAYS CLEAR VISION, daily, 30 lenses, Bluelight, cut, ANTI-BLUE LIGHT, contact lens, soft contact lens, original, Singapore',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS.`,
    canonicalUrl: `${baseCanonicalUrl}/clear-contactlens/daily-blue`,
  },
  {
    metaTitle: 'OWNDAYS CLEAR VISION DAILY',
    targetPath: '/contacts/clear-contactlens/daily',
    keywords:
      'OWNDAYS CLEAR VISION, daily, 30 lenses, contact lens, soft contact lens, original, Singapore',
    ogImage: null,
    description: `OWNDAYS CLEAR VISION DAILY - OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS. With huge emphasis on quality and material, OWNDAYS CLEAR VISION allows wearers to get through their daily activities with comfortable and refreshed vision. Easy to put on and conveniently available, OWNDAYS CLEAR VISION is the perfect contact lens for everyday use!`,
    canonicalUrl: `${baseCanonicalUrl}/clear-contactlens/daily`,
  },
  {
    metaTitle: 'OWNDAYS CLEAR VISION MONTHLY',
    targetPath: '/contacts/clear-contactlens/monthly',
    keywords: 'OWNDAYS CLEAR VISION, monthly, 6 lenses, soft contact lens, original, Singapore',
    ogImage: null,
    description: `OWNDAYS CLEAR VISION MONTHLY - OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS. With huge emphasis on quality and material, OWNDAYS CLEAR VISION allows wearers to get through their daily activities with comfortable and refreshed vision. Easy to put on and conveniently available, OWNDAYS CLEAR VISION is the perfect contact lens for everyday use!`,
    canonicalUrl: `${baseCanonicalUrl}/clear-contactlens/monthly`,
  },
  {
    metaTitle: 'OWNDAYS Clear Vision Contact Lens Guide | OWNDAYS Singapore',
    targetPath: '/contacts/clear-contactlens/how-to-use',
    keywords:
      'OWNDAYS CLEAR VISION, How to use, contact lens, 1 day, 30 prices, original, Singapore, OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS.`,
    canonicalUrl: `${baseCanonicalUrl}/clear-contactlens/how-to-use`,
  },
  {
    metaTitle: 'OWNDAYS CLEAR VISION | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/contacts/clear-contactlens',
    keywords:
      'OWNDAYS CLEAR VISION, contact lens, 1 day, monthly, original, Raffles City, Jurong Point, Waterway Point, Singapore, OWNDAYS',
    ogImage: null,
    description: `OWNDAYS CLEAR VISION is the in-house contact lens line from OWNDAYS.`,
    canonicalUrl: `${baseCanonicalUrl}/clear-contactlens`,
  },
  {
    metaTitle: 'OWNDAYS Natural Daily Contact Lens | OWNDAYS Singapore',
    targetPath: '/contacts/color-contactlens/natural',
    keywords:
      'OWNDAYS NATURAL DAILY, daily, 10 lenses, colour contact lens, soft contact lens, original, Singapore, OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `Discover the new you with colour contact lens by OWNDAYS!`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens/natural`,
  },
  {
    metaTitle: 'OWNDAYS Horoscope Daily Contact Lens | OWNDAYS Singapore',
    targetPath: '/contacts/color-contactlens/horoscope',
    keywords:
      'OWNDAYS HOROSCOPE DAILY, daily, 10 lenses, colour contact lens, soft contact lens, original, Singapore, OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `Discover the new you with colour contact lens by OWNDAYS!`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens/horoscope`,
  },
  {
    metaTitle: 'OWNDAYS Petal Montly Contact Lens | OWNDAYS Singapore',
    targetPath: '/contacts/color-contactlens/petal',
    keywords:
      'OWNDAYS PETAL MONTHLY,Monthly,10 lenses,colour contact lens,soft contact lens,original, Singapore, OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `Discover the new you with colour contact lens by OWNDAYS!`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens/petal`,
  },
  {
    metaTitle: 'OWNDAYS Velvet Monthly Contact Lens | OWNDAYS Singapore',
    targetPath: '/contacts/color-contactlens/velvet',
    keywords:
      'OWNDAYS VELVET MONTHLY, Monthly, 10 lenses, colour contact lens, soft contact lens, original, Singapore, OWNDAYS',
    ogImage: 'https://static.lenskart.com/media/owndays/manifest/fb/ogp_1200x630.jpg',
    description: `Discover the new you with colour contact lens by OWNDAYS!`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens/velvet`,
  },
  {
    metaTitle: 'HOW TO USE',
    targetPath: '/contacts/color-contactlens/how-to-use',
    keywords: 'OWNDAYS COLOUR CONTACT LENS, How to use, contact lens, 1 day, 10 prices, original',
    ogImage: null,
    description: `Correct way of using OWNDAYS COLOUR CONTACT LENS contact lenses. To protect the health of your eyes, here’s a guide on how to use the contact lenses correctly.`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens/how-to-use`,
  },
  {
    metaTitle: 'OWNDAYS COLOUR CONTACT LENS | OWNDAYS ONLINE STORE - OPTICAL SHOP',
    targetPath: '/contacts/color-contactlens',
    keywords: 'COLOUR CONTACT LENS, 4 series, daily, monthly, original, Singapore, OWNDAYS',
    ogImage: null,
    description: `Discover the new you with colour contact lens by OWNDAYS!`,
    canonicalUrl: `${baseCanonicalUrl}/color-contactlens`,
  },
];
